document.addEventListener('DOMContentLoaded', () => {

    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach(card => {

        const slides = card.querySelectorAll('.product-card__slide');
        const previousButton = card.querySelector('.product-card__arrow--left');
        const nextButton = card.querySelector('.product-card__arrow--right');

        if (slides.length <= 1) return;

        let currentIndex = 0;

        function showSlide(index) {

            slides[currentIndex].classList.remove('active');

            currentIndex = index;

            slides[currentIndex].classList.add('active');
        }

        previousButton.addEventListener('click', () => {

            const newIndex =
                currentIndex === 0
                    ? slides.length - 1
                    : currentIndex - 1;

            showSlide(newIndex);

        });

        nextButton.addEventListener('click', () => {

            const newIndex =
                currentIndex === slides.length - 1
                    ? 0
                    : currentIndex + 1;

            showSlide(newIndex);

        });

    });

});